import { BASE_URL } from "../config";
import axiosApiInstance from '../../interceptors/axiosApiInstance';

const RoleService = {
    getRoles: async function (params) {
        try {
            return await axiosApiInstance.get(await BASE_URL + '/role');
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    postActionAndPermission: async function (params) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + `/role/${params.id}/permission-action`,
                {
                    modules: params.modules,
                    actions: params.actions,
                    moduleStatus: params.moduleStatus
                }
            );
            return response.data
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    postRole: async function (params) {
        try {
            const response = await axiosApiInstance.post(
                await BASE_URL + `/role`,
                {
                    role_name: params.roleName,
                    role_description: params.description
                }
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    putRole: async function (data, id) {
        try {
            const response = await axiosApiInstance.put(await BASE_URL + `/role/${id}`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    deleteRole: async function (ids) {
        try {
            const response = await axiosApiInstance.delete(await BASE_URL + '/role', { data: { ids } });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    updateUserRoles: async function (data) {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + '/role/user-roles', data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getRoleModules: async function (id) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + '/role/' + id + '/modules');
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getRoleLibraries: async function (moduleID, roleID) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + '/module/' + moduleID + '/libraries?roleId=' + roleID);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    }
};

export default RoleService;
